/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button, Modal, Row, Col, Form, Select, message } from "antd";

import styles from "./../../style.module.scss";
import { useTranslation } from "react-i18next";

// redux & query
import { setRemoveDeviceModalVisible, setDeviceId } from "../../goSlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { useRemove } from "../../queries";

const { Option } = Select;

interface RemoveModalProps {
  deviceId: string;
}

const Remove_Modal: React.FC<RemoveModalProps> = (props) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { ticket } = useParams();

  const { deviceId, ticketData, removeDeviceModalVisible } = useAppSelector((state) => state.goPage);
  const { mutateAsync: useRemoveMutation } = useRemove();

  const handleOk = () => {
    dispatch(setRemoveDeviceModalVisible(false));
  };

  const handleCancel = () => {
    dispatch(setRemoveDeviceModalVisible(false));
  };

  const handleSubmit = async (ticket: any, id: any) => {
    await useRemoveMutation({ ticket, id })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
    dispatch(setRemoveDeviceModalVisible(false));
    dispatch(setDeviceId(""));
  };

  useEffect(() => {
    form.setFieldsValue({
      cid: ticketData?.ticket_inf?.cid,
      ticket: ticket,
      id: deviceId,
    });
  }, []);

  return (
    <>
      <Modal
        centered
        title={t("")}
        visible={removeDeviceModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button
            key="Cancel"
            onClick={() => {
              handleCancel();
            }}
          >
            {t("ISMS.Cancel")}
          </Button>,
          <Button
            type="primary"
            key="Submit"
            onClick={() => {
              handleSubmit(ticket, props.deviceId);
            }}
          >
            {t("ISMS.Submit")}
          </Button>,
        ]}
      >
        <Row justify="center" align="middle" style={{ paddingLeft: "3vw", paddingRight: "3vw" }}>
          <Col style={{ fontSize: "16px" }}>{`${t("ISMS.Confirm to remove device")}!`}</Col>
        </Row>
      </Modal>
    </>
  );
};

export default Remove_Modal;
